module.exports = __webpack_public_path__ + "img/four_circle.372c0f21.svg";